import { Pressable, StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { Text } from '@/components/Text';
import { useOnHover } from '@/hooks/useOnHover';
import { formatTagLabel } from '@/utils/stringHelpers';
import { styles } from './styles';

type TagProps = {
  label: string;
  testID?: string;
  isSelected?: boolean;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  selectedStyle?: StyleProp<ViewStyle>;
  selectedLabelStyle?: StyleProp<TextStyle>;
};

export const Tag = ({
  label,
  testID,
  isSelected = false,
  onPress,
  style,
  labelStyle,
  selectedStyle,
  selectedLabelStyle,
}: TagProps) => {
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();

  const containerStyle = [
    styles.container,
    style,
    isSelected && styles.selected,
    isSelected && selectedStyle,
    onPress &&
      isHovered &&
      (isSelected ? styles.hoveredSelected : styles.hovered),
  ];

  const content = (
    <Text
      style={[
        styles.label,
        labelStyle,
        isSelected && styles.labelSelected,
        isSelected && selectedLabelStyle,
      ]}
      numberOfLines={1}
      ellipsizeMode="tail"
    >
      {formatTagLabel(label)}
    </Text>
  );

  if (!onPress) {
    return (
      <View testID={testID} style={containerStyle}>
        {content}
      </View>
    );
  }

  return (
    <Pressable
      testID={testID}
      onPress={onPress}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      style={containerStyle}
      accessibilityRole="button"
      accessibilityState={{ selected: isSelected }}
    >
      {content}
    </Pressable>
  );
};
